<template lang="pug">
  v-card.my-5
    template(v-if="!item")
      page-loading
    template(v-if="item")
      v-toolbar(dense color="info")
        div 文章狀態：{{ item.data.published ? "已發布" : "草稿" }}
        v-spacer
        v-toolbar-items
          v-btn(flat color="white" @click="save") 儲存
          template
            v-btn(v-if="!item.data.published" flat color="white" @click="publish") 發布
            v-btn(v-else flat color="white" @click="unpublish") 轉為草稿
          v-btn(flat color="error" @click="deleteItem") 刪除
      v-container
        p.display-1.mb-3 標題
        v-text-field(v-model="item.data.title"
          label="文章標題")
        p.display-1.mb-3 活動時間
        v-date-picker(v-model="eventTime"
          label="活動時間"
          locale="zh-cn")
        p.display-1.mb-3 封面
        new-cover-editor.pa-3(:src="$u.get(item, 'data.cover.src', '')"
          @upload="updateCover($event)"
          @clear="clearCover")
        p.display-1.mb-3 內文
        text-editor(:value.sync="item.data.content")
        p.display-1.mb-3 檔案
        new-files-editor(:items="item.data.files"
          @upload="uploadFiles($event)"
          @update="updateFiles($event)"
          @delete="deleteFile($event)")
        p.display-1.mb-3 照片
        new-photo-editor(:articleId="innerId")
        v-container
          v-layout(wrap)
            v-flex.pa-2(v-for="(photo, index) in item.data.photos" xs3 sm2 lg1)
              v-hover
                v-card(flat slot-scope="{ hover }")
                  v-img(:aspect-ratio="1" :src="photo.thumbSrc || ''")
                  v-btn.error.white--text.text-center(v-if="hover" :style="{ height: '100%' }" flat block @click="deletePhoto(index)") 刪除
    check-dialog(:open="saveDialog" title="已儲存" @check="saveDialog = false")
    check-dialog(:open="checkDialog" title="成功" @check="$router.push({ name: 'cms' })")
</template>
<script>
import uniqid from "uniqid";
import { db, FieldValue, storage, photoStorage } from "@/firebase";
import NewCoverEditor from "@/components/cms/newCoverEditor.vue";
import TextEditor from "@/components/cms/TextEditor.vue";
import NewFilesEditor from "@/components/cms/newFilesEditor.vue";
import NewPhotoEditor from "@/components/cms/newPhotoEditor.vue";
import CheckDialog from "@/components/core/CheckDialog.vue";
import PageLoading from "@/components/core/PageLoading.vue";

export default {
  name: "newArticleEditor",
  components: {
    NewCoverEditor,
    TextEditor,
    NewFilesEditor,
    NewPhotoEditor,
    CheckDialog,
    PageLoading
  },
  props: {
    type: {
      type: String,
      required: true
    },
    id: {
      type: String,
      default: null // creation mode when null;
    }
  },
  data() {
    return {
      innerId: this.id || db.collection("articles").doc().id,
      item: null,
      unsubscribe: null,
      checkDialog: false,
      saveDialog: false,
      eventTimeInput: null
    };
  },
  async mounted() {
    if (this.id) {
      this.unsubscribe = await db
        .doc(`articles/${this.innerId}`)
        .onSnapshot(doc => {
          let currentData = this.item
            ? { title: this.item.data.title, content: this.item.data.content }
            : {};

          this.item = {
            id: doc.id,
            data: {
              ...doc.data(),
              ...currentData
            }
          };
        });
    } else {
      await db.doc(`articles/${this.innerId}`).set({
        eventTime: null,
        content: "",
        cover: null,
        type: this.type,
        title: "",
        files: [],
        photos: [],
        published: false,
        creationTime: FieldValue.serverTimestamp()
      });
      this.unsubscribe = await db
        .doc(`articles/${this.innerId}`)
        .onSnapshot(doc => {
          this.item = { id: doc.id, data: doc.data() };
        });
    }
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
  },
  computed: {
    eventTime: {
      get() {
        return this.item.data.eventTime
          ? new Date(this.item.data.eventTime)
              .toLocaleDateString()
              .replace(/\//g, "-")
          : null;
      },
      set(v) {
        this.item.data.eventTime = new Date(`${v} 00:00`).toISOString();
      }
    }
  },
  methods: {
    async updateCover(file) {
      if (file) {
        const ext = file.name.replace(/.*\./g, ".");
        const strageRef = photoStorage.ref("typt-82327");
        const ref = strageRef.child(`articles/${this.item.id}/cover${ext}`);
        await ref.put(file);
        const downloadURL = await ref.getDownloadURL();
        await this.update({ "cover.src": downloadURL });
      }
    },
    async clearCover() {
      await this.update({ cover: "" });
    },
    async update(data) {
      await db.doc(`articles/${this.item.id}`).update(data);
    },
    async save() {
      await db.doc(`articles/${this.item.id}`).update({
        eventTime: this.item.data.eventTime,
        title: this.item.data.title,
        content: this.item.data.content
      });
      this.saveDialog = true;
    },
    async deleteItem() {
      await db.doc(`articles/${this.item.id}`).delete();
      this.checkDialog = true;
    },
    async publish() {
      await db.doc(`articles/${this.item.id}`).update({
        title: this.item.data.title,
        content: this.item.data.content,
        published: true
      });
      this.checkDialog = true;
    },
    async unpublish() {
      await db.doc(`articles/${this.item.id}`).update({
        title: this.item.data.title,
        content: this.item.data.content,
        published: false
      });
      this.checkDialog = true;
    },
    async uploadFiles(filesResult) {
      const strageRef = storage.ref();
      const uploadList = [];

      filesResult.forEach(item => {
        if (item.src) return;

        const filename = uniqid();
        const ext = item.file.name.replace(/.*\./g, ".");
        const size = item.file.size;
        const filepath = `files/articles/${filename}${ext}`;
        const ref = strageRef.child(filepath);

        uploadList.push(
          ref.put(item.file).then(() => {
            return ref.getDownloadURL().then(url => {
              item.url = url;
              item.size = size;
              item.ext = ext;
              delete item.file;
            });
          })
        );
      });

      await Promise.all(uploadList);
      await this.update({ files: filesResult });
    },
    async updateFiles(files) {
      await this.update({
        files
      });
    },
    async deleteFile(index) {
      const result = this.item.data.files.slice();
      result.splice(index, 1);
      await this.update({
        files: result
      });
    },
    async deletePhoto(index) {
      const result = this.item.data.photos.slice();
      result.splice(index, 1);
      await this.update({
        photos: result
      });
    }
  }
};
</script>
